import { Controller } from "@hotwired/stimulus"

const TRANSLATIONS = {
  "pt-BR": {
    success: 'Link de acesso copiado com sucesso! Envie para o usuário colando o link em qualquer mensagem.',
    unable: 'Não foi possível copiar o link automaticamente.',
    error: 'Erro ao copiar o link automaticamente.'
  },
  "en": {
    success: 'Access link copied successfully! Send it to the user by pasting it in any message.',
    unable: 'Unable to copy the link automatically.',
    error: 'Error copying the link automatically.'
  }
}

export default class extends Controller {
  static values = { url: String, locale: { type: String, default: "pt-BR" } }

  connect() {
    if (this.urlValue) {
      this.copyToClipboard(this.urlValue)
    }
  }

  get t() {
    const locale = TRANSLATIONS[this.localeValue] ? this.localeValue : "pt-BR"
    return TRANSLATIONS[locale]
  }

  copyToClipboard(text) {
    const textarea = document.createElement("textarea")
    textarea.style.position = 'fixed'
    textarea.style.top = '0'
    textarea.style.left = '0'
    textarea.style.width = '2em'
    textarea.style.height = '2em'
    textarea.style.padding = '0'
    textarea.style.border = 'none'
    textarea.style.outline = 'none'
    textarea.style.boxShadow = 'none'
    textarea.style.background = 'transparent'
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        alert(this.t.success)
      } else {
        alert(this.t.unable)
      }
    } catch (err) {
      alert(this.t.error)
    }

    document.body.removeChild(textarea)
  }
}
